import React from "react"
// import { ThemeToggler } from "gatsby-plugin-dark-mode"
import { styled } from 'twin.macro'

export default function ThemeToggle() {
    return (
      <>
      {/* {({ theme, toggleTheme }) => (
        <LabelIcon>
            <ModeToggle type="checkbox" className=""
              onChange={e => 
                toggleTheme(e.target.checked ? 'dark' : 'light')}
                checked={theme === 'dark'}
              />{' '}  
          
          {theme === 'dark' ? (
            <Sun size="24" className="transition-colors hover:text-yellow-500"/>
            ) : (
              <Moon size="24" className="transition-colors hover:text-violet-600" />
            )}         
        </LabelIcon>    
        
        )} */}
      </>
    )
}

// @styled-icons/boxicons-regular/Sun
// @styled-icons/boxicons-solid/Moon
// @styled-icons/entypo/Moon